/**
 * 文件功能：应用入口文件（Vue 3 版本）
 * 输入参数：无（加载根组件 App.vue、路由、全局插件）
 * 输出参数：无（挂载到 #app DOM 节点）
 * 返回值：无
 * 说明：注册 Element Plus、animal-island-vue 动森组件库样式、font-awesome 图标与全局样式，
 *       并将 $request / $baseUrl 挂载为全局属性供组件使用。
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import 'font-awesome/css/font-awesome.css'
import 'animal-island-vue/style'
import '@/assets/css/global.css'
import request from '@/utils/request'

const app = createApp(App)

app.use(router)
app.use(ElementPlus, { locale: zhCn, size: 'default' })

app.config.globalProperties.$request = request
app.config.globalProperties.$baseUrl = process.env.VUE_APP_BASEURL

app.mount('#app')
